import Icon from '../components/Icon.vue'

Icon.register({
  'funnel-dollar': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M433.5 165.9L534.7 54.1C554.6 34.1 540.5 0 512.3 0H31.7C3.5 0-10.6 34.1 9.3 54.1L192 256V411.9C192 424.5 197.9 436.4 208 443.9L288 503.9C308.9 519.6 336.5 510.9 347.2 490.4 310.8 455.4 288 406.4 288 352 288 262.2 350.1 186.8 433.5 165.9zM480 192C391.6 192 320 263.6 320 352S391.6 512 480 512 640 440.4 640 352 568.4 192 480 192zM496 431.9V448C496 452.4 492.4 456 488 456H472C467.6 456 464 452.4 464 448V431.7C452.7 431.1 441.7 427.2 432.6 420.4 428.7 417.4 428.5 411.6 432.1 408.2L443.8 397C446.6 394.4 450.7 394.3 453.9 396.3 457.8 398.7 462.2 400 466.8 400H494.9C501.4 400 506.7 394.1 506.7 386.8 506.7 380.9 503.1 375.6 497.9 374.1L452.9 360.6C434.3 355 421.3 337.2 421.3 317.2 421.3 292.7 440.4 272.8 464 272.1V256C464 251.6 467.6 248 472 248H488C492.4 248 496 251.6 496 256V272.3C507.3 272.9 518.3 276.8 527.4 283.6 531.3 286.6 531.5 292.4 527.9 295.8L516.2 307C513.4 309.6 509.3 309.8 506.1 307.7 502.2 305.3 497.8 304 493.2 304H465.1C458.6 304 453.3 309.9 453.3 317.2 453.3 323.1 456.9 328.4 462.1 329.9L507.1 343.4C525.7 349 538.7 366.8 538.7 386.8 538.7 411.3 519.6 431.3 496 431.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/funnel-dollar.js
// module id = v6hx
// module chunks = 144